

$(document).ready(function(){

  //header announcement 
  $('.announcement-close').click(function(){
    $(this).parents('#shopify-section-header-announcement-bar').css('display','none');
  });

  // fairness goal
  //    $('.fairness-content-wrapper .product-accordion__clickable').click(function(){
  //       $('.fairness-inner-wrap').removeClass('active');
  //     	$(this).parent('.fairness-inner-wrap').addClass('active');
  //     });
  $('.fairness-content-wrapper .fairness-left-title').click(function(){
    if(!$(this).parents('.fairness-inner-wrap').hasClass('active')){
      $('.fairness-inner-wrap').removeClass('active');      
    }
    $(this).parents('.fairness-inner-wrap').toggleClass('active');
  });

  // ========================Menu Hover(draw Theme) ================
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  items.forEach(item => {
    item.addEventListener("mouseover", (e) => {
      e.preventDefault();
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
                                                item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
                          item.removeAttribute("open");
  });
});
});

  // $('#home-customer-solution').slick({
  //   infinite: true,
  //   arrows: true,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   autoplaySpeed: 2000,
  //   responsive: [
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1
  //       },
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       },
  //     }
  //   ]
  // });

  //feature collection
  $('#productslider').slick({
    infinite: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        },
      }
    ]
  });

  // feature blog section
  var blog_show = $('.feature-blog .blog__posts').data('blog-show');
  $('.feature-blog .blog__posts').slick({
    infinite: false,
    arrows: true,
    slidesToShow: blog_show,
    slidesToScroll: 1,
    prevArrow: '<div class="prev-arrow"></div>',
    nextArrow: '<div class="next-arrow"></div>',
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        },
      }
    ]
  });

  //customer review section
  $('.customer-review-section .customer-review-wrapper').slick({
    infinite: false,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<div class="prev-arrow"></div>',
    nextArrow: '<div class="next-arrow"></div>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        },
      },
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        },
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        },
      }
    ]
  });

  // product page 'abo' tag products
  // $('.collection-abos-product .collection-productlist').slick({
  //   infinite: false,
  //   arrows: true,
  //   prevArrow: '<div class="slickprev-arrow"><svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.64453 3.99622L13.4781 10.5879L15.1445 8.70494L7.64453 0.230316L0.144531 8.70494L1.81094 10.5879L7.64453 3.99622Z" fill="#606060"/></svg></div>',
  //   nextArrow:'<div class="slicknext-arrow"><svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.64453 7.46472L13.4781 0.873047L15.1445 2.756L7.64453 11.2306L0.144531 2.756L1.81094 0.873047L7.64453 7.46472Z" fill="#606060"/></svg></div>',
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1
  //       },
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       },
  //     }
  //   ]
  // });


  /* new popup */
  /* $('.header .header__icons .login_button_block .cm_btn').click(function(e){
    e.preventDefault();
    $(".login-popup-wrap").addClass("active");
  });

  $(".login-popup-close").click(function(){
    $(".login-popup-wrap").removeClass("active");
  });*/

  $(".login-popup-close").click(function(){
    $(".login-popup-wrap").removeClass("active");
  });

  
  // user account popup

  $('.header__icons .headeruser-info-active').click(function(e){
    e.preventDefault();
    $('body').addClass('bodyuser-popup');
    $('.user-login-popup').addClass('loginpopup-open');
  });

  $('.user-login-popup .login-close-btn').click(function(){
    $('body').removeClass('bodyuser-popup');
    $('.user-login-popup').removeClass('loginpopup-open');
  });

  $('.loginpopuptarget').click(function(e){
    setTimeout(function(){
      var url = location.origin; 
      var otherpage_url = location.pathname;
      var newurl='';
      if(otherpage_url != '/'){
        newurl = url +''+otherpage_url;
        history.pushState({}, '', newurl);
      }else{
        newurl = url;
        history.pushState({}, '', newurl);
      }
    },200);
  });

  $('.slider-for #Slider-Gallery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    focusOnSelect: false,
     adaptiveHeight: true,
    infinite:false,
    asNavFor: '.slider-nav #Slider-Thumbnails',
    prevArrow: '<div class="prev-arrow"><svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.64453 3.99622L13.4781 10.5879L15.1445 8.70494L7.64453 0.230316L0.144531 8.70494L1.81094 10.5879L7.64453 3.99622Z" fill="#606060"/></svg></div>',
    nextArrow:'<div class="next-arrow"><svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.64453 7.46472L13.4781 0.873047L15.1445 2.756L7.64453 11.2306L0.144531 2.756L1.81094 0.873047L7.64453 7.46472Z" fill="#606060"/></svg></div>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  }); 

  $('.slider-nav #Slider-Thumbnails').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: true,
     adaptiveHeight: true,
    infinite:false,
    arrows: true,
    autoplay: false,
    prevArrow: '<div class="prev-arrow"><svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.64453 3.99622L13.4781 10.5879L15.1445 8.70494L7.64453 0.230316L0.144531 8.70494L1.81094 10.5879L7.64453 3.99622Z" fill="#606060"/></svg></div>',
    nextArrow:'<div class="next-arrow"><svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.64453 7.46472L13.4781 0.873047L15.1445 2.756L7.64453 11.2306L0.144531 2.756L1.81094 0.873047L7.64453 7.46472Z" fill="#606060"/></svg></div>',
    asNavFor: '.slider-for #Slider-Gallery',
    responsive: [
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.faq-que-ans .faq-que').click(function(){
    $('.faq-que-ans').not($(this).parent()).removeClass('active');
    $(this).parent().toggleClass('active');
    $('.faq-ans').not($(this).siblings()).slideUp();
    $(this).siblings().slideToggle();
  });

  //collection page filter mobile 
  $(document).click(function(e) {
    var container = $("#FacetFiltersFormMobile .mobile-facets__inner");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0 )
    {
      $('.mobile-facets__close').trigger('click');
    }
  });
  
  
  
  
  $('.our-customer-sec .our-customer-inner').slick({
    slidesToShow:6,
    slidesToScroll: 1,
    infinite:true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  
//   Customer Solution
    $('.cust-solu-main-content .cust-solu-inner-content').slick({
    centerMode: true,
    centerPadding: '300px',
    slidesToShow: 2,
    arrows: true,
    prevArrow:
      '<button class="slick-prev slick-arrow"><svg class="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path id="down" d="M0,12A12,12,0,1,1,12,24,12,12,0,0,1,0,12Zm16.679,2.5a1.118,1.118,0,0,0,1.575,0,1.1,1.1,0,0,0,.323-.785,1.119,1.119,0,0,0-.329-.79l-5.44-5.423a1.112,1.112,0,0,0-1.535.035l-5.521,5.5a1.114,1.114,0,0,0,1.575,1.575l4.679-4.725Z" transform="translate(24) rotate(90)" fill="#fff"></path></svg></button>',
    nextArrow:
      '<button class="slick-next slick-arrow"><svg class="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path id="down" d="M0,12A12,12,0,1,1,12,24,12,12,0,0,1,0,12Zm16.679,2.5a1.118,1.118,0,0,0,1.575,0,1.1,1.1,0,0,0,.323-.785,1.119,1.119,0,0,0-.329-.79l-5.44-5.423a1.112,1.112,0,0,0-1.535.035l-5.521,5.5a1.114,1.114,0,0,0,1.575,1.575l4.679-4.725Z" transform="translate(24) rotate(90)" fill="#fff"></path></svg></button>',
    dots: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          centerMode: true,
          centerPadding: '200px',
        }
      },
      {
        breakpoint: 1280,
        settings: {
          centerMode: true,
          centerPadding: '100px',
        }
      },
      {
        breakpoint: 990,
        settings: {
          centerMode: true,
          centerPadding: '80px',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          centerMode: true,
          centerPadding: '60px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 1
        }
      }
    ]
  });
  
  
  $('.cus-review-main-content').slick({
    centerMode: true,
    centerPadding: '300px',
    slidesToShow: 2,
    arrows: true,
    prevArrow:
      '<button class="slick-prev slick-arrow"><svg class="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path id="down" d="M0,12A12,12,0,1,1,12,24,12,12,0,0,1,0,12Zm16.679,2.5a1.118,1.118,0,0,0,1.575,0,1.1,1.1,0,0,0,.323-.785,1.119,1.119,0,0,0-.329-.79l-5.44-5.423a1.112,1.112,0,0,0-1.535.035l-5.521,5.5a1.114,1.114,0,0,0,1.575,1.575l4.679-4.725Z" transform="translate(24) rotate(90)" fill="#fff"></path></svg></button>',
    nextArrow:
      '<button class="slick-next slick-arrow"><svg class="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path id="down" d="M0,12A12,12,0,1,1,12,24,12,12,0,0,1,0,12Zm16.679,2.5a1.118,1.118,0,0,0,1.575,0,1.1,1.1,0,0,0,.323-.785,1.119,1.119,0,0,0-.329-.79l-5.44-5.423a1.112,1.112,0,0,0-1.535.035l-5.521,5.5a1.114,1.114,0,0,0,1.575,1.575l4.679-4.725Z" transform="translate(24) rotate(90)" fill="#fff"></path></svg></button>',
    dots: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          centerMode: true,
          centerPadding: '200px',
        }
      },
      {
        breakpoint: 1280,
        settings: {
          centerMode: true,
          centerPadding: '100px',
        }
      },
      {
        breakpoint: 990,
        settings: {
          centerMode: true,
          centerPadding: '80px',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          centerMode: true,
          centerPadding: '60px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 1
        }
      }
    ]
  });
  


// Back To Top  
  var btn = $('#toTop');
  $(window).scroll(function() {
    if ($(window).scrollTop() > 50) {
      btn.addClass('show');
    } else {
      btn.removeClass('show');
    }
  });

  btn.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop:0}, '50');
  });
  
//   Scroll Contact Form sticky
  //  var btn_bottom = $('#home-contact-form');
  // $(window).scroll(function() {
  //   if ($(window).scrollTop() > 50) {
  //     btn_bottom.addClass('show');
  //   } else {
  //     btn_bottom.removeClass('show');
  //   }
  // });
  // btn_bottom.on('click', function(e) {
  //   e.preventDefault();
  //   $('html, body').animate({scrollTop:0}, '50');
  // });

 
//   Animation Js
   
  
 

  // product tag abos product add to cart

  if($('.collection-abos-product .collection-tag-product').length <= 0){
    $('.collection-abos-product .tag-collection-title').css('display','none');
  }
    $('.collection-abos-product .collection-tag-product .disable-popupbtn').click(function(){
      $(".home-sticky-bottom").trigger('click');
    });
  
    $('.collection-tag-product .product-tag-cartbtn').click(function(){
    var cartproductvariant = $(this).data('cartvariantproduct');
    var cartqty= 1;
    var cartsellingplan = $(this).data('cartsellingplan');
    var tempdata;
    if (cartsellingplan){
    tempdata = {id:cartproductvariant, quantity:cartqty,selling_plan:cartsellingplan}; 
    }else{
      tempdata = {id:cartproductvariant, quantity:cartqty}; 
    }
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: tempdata,
        dataType: 'json',
        success: function(cart) { 
            window.location.href = "/cart";
        }
      }); 
  });

  /*$('.customer_select.customer_kunde').click(function(){
    
    var cartqty= 1;
    
    var tempdatacart;
    
    tempdatacart = {id:43569183326434, quantity:cartqty}; 
    
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: tempdatacart,
        dataType: 'json',
        success: function(cart) { 
            window.location.href = "/collections";
        }
      }); 
  });*/
  
});



jQuery(function($) {
    jQuery(document).ready(function(){  
       $('.your-slider').slick({
           infinite: true,
           slidesToShow: 3,
           slidesToScroll: 3
       });


    }); 
});


    
$(document).ready(function(){

  $(".header__inline-menu #digitale-visitenkarten").click(function() {
      $('html, body').animate({
          scrollTop: $("#tribus_card_id").offset().top - 120
      }, 600);
      
  });
  $(".header__inline-menu #qr-codes").click(function() {
    
        $('html, body').animate({
            scrollTop: $("#tribus_code_id").offset().top - 120
        }, 600);
        
  });
  $(".header__inline-menu #webseite-fur-alles").click(function() {
     
        $('html, body').animate({
            scrollTop: $("#tribus_site_id").offset().top - 120
        }, 600);
     
  });
  $(".header__inline-menu #nfc-tags").click(function() {
     
        $('html, body').animate({
            scrollTop: $("#tribus_tag_id").offset().top - 120
        }, 600);
     
  });
  $(".header__inline-menu #managementplattform").click(function() {
     
        $('html, body').animate({
            scrollTop: $("#tribus_management_id").offset().top - 120
        }, 600);
     
  });
  $(".header__inline-menu #gastro-losungen").click(function() {
     
        $('html, body').animate({
            scrollTop: $("#tribus_gastro_id").offset().top - 120
        }, 600);
     
  });

  
 $(".menu-drawer__menu #digitale-visitenkarten").click(function() {
   $('#Details-menu-drawer-container').attr('open',false);
   $('#Details-menu-drawer-container').removeClass('menu-opening');
   $('body').removeClass('overflow-hidden-tablet');
   
    setTimeout(function() {
    console.log('hii');
      $('html, body').animate({
          scrollTop: $("#tribus_card_id").offset().top - 100
      }, 600);
       }, 300);
  });
  $(".menu-drawer__menu #qr-codes").click(function() {
     $('#Details-menu-drawer-container').attr('open',false);
   $('#Details-menu-drawer-container').removeClass('menu-opening');
   $('body').removeClass('overflow-hidden-tablet');
    setTimeout(function() {
      console.log('hii');
        $('html, body').animate({
            scrollTop: $("#tribus_code_id").offset().top - 100
        }, 600);
         }, 300);
  });
  $(".menu-drawer__menu #webseite-fur-alles").click(function() {
     $('#Details-menu-drawer-container').attr('open',false);
   $('#Details-menu-drawer-container').removeClass('menu-opening');
   $('body').removeClass('overflow-hidden-tablet');
    setTimeout(function() {
      console.log('hii');
        $('html, body').animate({
            scrollTop: $("#tribus_site_id").offset().top - 100
        }, 600);
     }, 300);
  });
  $(".menu-drawer__menu #nfc-tags").click(function() {
     $('#Details-menu-drawer-container').attr('open',false);
   $('#Details-menu-drawer-container').removeClass('menu-opening');
   $('body').removeClass('overflow-hidden-tablet');
    setTimeout(function() {
      console.log('hii');
        $('html, body').animate({
            scrollTop: $("#tribus_tag_id").offset().top - 100
        }, 600);
     }, 300);
  });
  $(".menu-drawer__menu #managementplattform").click(function() {
     $('#Details-menu-drawer-container').attr('open',false);
   $('#Details-menu-drawer-container').removeClass('menu-opening');
   $('body').removeClass('overflow-hidden-tablet');
    setTimeout(function() {
      console.log('hii');
        $('html, body').animate({
            scrollTop: $("#tribus_management_id").offset().top - 100
        }, 600);
     }, 300);
  });
  $(".menu-drawer__menu #gastro-losungen").click(function() {
     $('#Details-menu-drawer-container').attr('open',false);
   $('#Details-menu-drawer-container').removeClass('menu-opening');
   $('body').removeClass('overflow-hidden-tablet');
    setTimeout(function() {
      console.log('hii');
        $('html, body').animate({
            scrollTop: $("#tribus_gastro_id").offset().top - 100
        }, 600);
     }, 300);
  });
});



// End Scroll to Top


// toggle project
$(document).ready(function() {
  $(".is--our-card-grid-section .button--primary").click(function(event){
    event.preventDefault();
    $(".is--our-card-grid-section .multicolumn-list").toggleClass("active");
    $(this).toggleClass("active");
  });
});
$(document).ready(function() {
  $('#toBottom').click(function() {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $('section').next().offset().top + 80
    }, 800);
  });
});


$(document).ready(function() {
  $('.main_subscription .nc_types').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
         slidesToShow: 2,
        }
      },
      {
        breakpoint: 576,
        settings: {
         slidesToShow: 1,
        }
      }
    ]
  });
});